window.SizeGuideData = {
  'men-top': {
    instructions: [
      {
        title: 'Chest',
        description:
          'Measure around the fullest part of your chest. Keep the measuring tape horizontal (Approximately 1" below the armpit line)',
      },
      {
        title: 'Waist',
        description:
          'Measure around your natural waistline. Bend to the side to find the natural crease of your waist, measure at this point. (Approximately in line with your belly button)',
      },
    ],
    image: "{{ 'SizeChart_Mens.png' | asset_url }}",
    data: [
      {
        Size: 'XS',
        Chest: { in: '35-37', cm: '89-94' },
        Waist: { in: '28', cm: '71' },
      },
      {
        Size: 'S',
        Chest: { in: '37-39', cm: '94-99' },
        Waist: { in: '30', cm: '76' },
      },
      {
        Size: 'M',
        Chest: { in: '39-42', cm: '99-107' },
        Waist: { in: '32', cm: '81' },
      },
      {
        Size: 'L',
        Chest: { in: '42-45', cm: '107-114' },
        Waist: { in: '34', cm: '86' },
      },
      {
        Size: 'XL',
        Chest: { in: '45-48', cm: '114-122' },
        Waist: { in: '37', cm: '94' },
      },
      {
        Size: '2XL',
        Chest: { in: '48-50', cm: '122-127' },
        Waist: { in: '40', cm: '102' },
      },
      {
        Size: '3XL',
        Chest: { in: '51-53', cm: '130-135' },
        Waist: { in: '42', cm: '107' },
      },
    ],
  },
  'men-bottom': {
    instructions: [
      {
        title: 'Waist',
        description:
          'Measure around your natural waistline. Bend to the side to find the natural crease of your waist, measure at this point. (Approximately in line with your belly button)',
      },
      {
        title: 'Hips',
        description:
          'Hips are measured by standing feet together and measuring around the widest part of your hips (Approximately at the center of your glutes)',
      },
    ],
    image: "{{ 'SizeChart_Mens.png' | asset_url }}",
    data: [
      {
        Size: 'XS',
        Waist: { in: '28', cm: '71' },
        Hips: { in: '34-36', cm: '86-91' },
      },
      {
        Size: 'S',
        Waist: { in: '30', cm: '76' },
        Hips: { in: '36-38', cm: '91-97' },
      },
      {
        Size: 'M',
        Waist: { in: '32', cm: '81' },
        Hips: { in: '38-40', cm: '97-102' },
      },
      {
        Size: 'L',
        Waist: { in: '34', cm: '86' },
        Hips: { in: '40-42', cm: '102-107' },
      },
      {
        Size: 'XL',
        Waist: { in: '37', cm: '94' },
        Hips: { in: '43-44', cm: '109-112' },
      },
      {
        Size: '2XL',
        Waist: { in: '40', cm: '102' },
        Hips: { in: '45-47', cm: '114-119' },
      },
      {
        Size: '3XL',
        Waist: { in: '42', cm: '107' },
        Hips: { in: '48-50', cm: '122-127' },
      },
    ],
  },
  'women-top': {
    instructions: [
      {
        title: 'Bust',
        description:
          'Wrap a measuring tape around the fullest part of your bust. Make sure the tape is parallel to the ground.',
      },
      {
        title: 'Waist',
        description:
          'Wrap a measuring tape around the smallest part of your waist.',
      },
      {
        title: 'Hips',
        description:
          'Standing with your feet together, wrap the measuring tape around the fullest part of your glutes.',
      },
    ],
    image: "{{ 'SizeChart_Womens.png' | asset_url }}",
    data: [
      {
        Size: '2XS',
        Bust: { in: '30-31', cm: '76.2-78.7' },
        Waist: { in: '23-24', cm: '58.4-61' },
        Hips: { in: '33-34', cm: '83.8-86.4' },
      },
      {
        Size: 'XS',
        Bust: { in: '32-33', cm: '81.3-83.8' },
        Waist: { in: '25-26', cm: '63.5-66' },
        Hips: { in: '35-36', cm: '89-91.4' },
      },
      {
        Size: 'S',
        Bust: { in: '34-35', cm: '86.4-89' },
        Waist: { in: '27-28', cm: '68.6-71' },
        Hips: { in: '37-38', cm: '94-96.5' },
      },
      {
        Size: 'M',
        Bust: { in: '36-37', cm: '91.4-94' },
        Waist: { in: '29-30', cm: '73.6-76.2' },
        Hips: { in: '39-40', cm: '99-101.6' },
      },
      {
        Size: 'L',
        Bust: { in: '38-39', cm: '96.5-99' },
        Waist: { in: '31-32', cm: '78.7-81.3' },
        Hips: { in: '41-42', cm: '104-106.7' },
      },
      {
        Size: 'XL',
        Bust: { in: '40-41', cm: '101.6-104' },
        Waist: { in: '33-34', cm: '83.8-86.4' },
        Hips: { in: '43-44', cm: '109-111.8' },
      },
      {
        Size: '2XL',
        Bust: { in: '42-43', cm: '106.7-109' },
        Waist: { in: '35-36', cm: '89-91.4' },
        Hips: { in: '45-46', cm: '114.3-116.8' },
      },
    ],
  },
  'women-bottom': {
    instructions: [
      {
        title: 'Hips',
        description:
          'Standing with your feet together, wrap the measuring tape around the fullest part of your glutes.',
      },
      {
        title: 'Waist',
        description:
          'Wrap a measuring tape around the smallest part of your waist.',
      },
      {
        title: 'Inseam',
        description:
          'Standing with straight legs, measure along the inside length of your leg from groin to ankle bone.',
      },
    ],
    image: "{{ 'SizeChart_Womens.png' | asset_url }}",
    data: [
      {
        Size: '2XS',
        Waist: { in: '23-24', cm: '58.4-61' },
        Hips: { in: '33-34', cm: '83.8-86.4' },
      },
      {
        Size: 'XS',
        Waist: { in: '25-26', cm: '63.5-66' },
        Hips: { in: '35-36', cm: '89-91.4' },
      },
      {
        Size: 'S',
        Waist: { in: '27-28', cm: '68.6-71' },
        Hips: { in: '37-38', cm: '94-96.5' },
      },
      {
        Size: 'M',
        Waist: { in: '29-30', cm: '73.6-76.2' },
        Hips: { in: '39-40', cm: '99-101.6' },
      },
      {
        Size: 'L',
        Waist: { in: '31-32', cm: '78.7-81.3' },
        Hips: { in: '41-42', cm: '104-106.7' },
      },
      {
        Size: 'XL',
        Waist: { in: '33-34', cm: '83.8-86.4' },
        Hips: { in: '43-44', cm: '109-111.8' },
      },
      {
        Size: '2XL',
        Waist: { in: '35-36', cm: '89-91.4' },
        Hips: { in: '45-46', cm: '114.3-116.8' },
      },
    ],
  },
  'women-bra': {
    instructions: [
      {
        title: 'Bust',
        description:
          'Measure around the fullest part of your chest. Keep the measuring tape horizontal',
      },
    ],
    image: "{{ 'SizeChart_Womens.png' | asset_url }}",
    data: [
      {
        Size: { in: '28', cm: '71' },
        AA: '2XS',
        A: '2XS',
        B: 'XS',
        C: 'XS',
        D: 'S',
        'D+': 'M',
      },
      {
        Size: { in: '30', cm: '76' },
        AA: '2XS',
        A: 'XS',
        B: 'XS',
        C: 'S',
        D: 'M',
        'D+': 'M',
      },
      {
        Size: { in: '32', cm: '81' },
        AA: 'XS',
        A: 'XS',
        B: 'S',
        C: 'S',
        D: 'M',
        'D+': 'M',
      },
      {
        Size: { in: '34', cm: '86' },
        AA: 'XS',
        A: 'S',
        B: 'S',
        C: 'M',
        D: 'M',
        'D+': 'L',
      },
      {
        Size: { in: '36', cm: '91' },
        AA: 'S',
        A: 'S',
        B: 'M',
        C: 'M',
        D: 'M',
        'D+': 'L',
      },
      {
        Size: { in: '38', cm: '96' },
        AA: 'S',
        A: 'M',
        B: 'M',
        C: 'L',
        D: 'L',
        'D+': 'XL',
      },
      {
        Size: { in: '40', cm: '101' },
        AA: 'M',
        A: 'L',
        B: 'L',
        C: 'L',
        D: 'XL',
        'D+': '2XL',
      },
      {
        Size: { in: '42', cm: '106' },
        AA: 'L',
        A: 'XL',
        B: 'XL',
        C: 'XL',
        D: 'XL',
        'D+': '2XL',
      },
      {
        Size: { in: '44', cm: '111' },
        AA: 'XL',
        A: '2XL',
        B: '2XL',
        C: '2XL',
        D: '2XL',
        'D+': '-',
      },
    ],
  },
  kneesleeve: {
    instructions: [
      {
        title: 'Foot Size',
        description:
          'Stand with your heel against a wall, trace your foot on the paper, and then measure from the heel to the longest toe.',
      },
    ],
    data: [
      {
        Size: "US Men's 5",
        'EU 38': { in: '9 3/8', cm: '23.8' },
      },
      {
        Size: "US Men's 6",
        'EU 39': { in: '9 3/4', cm: '24.8' },
      },
      {
        Size: "US Men's 7",
        'EU 40': { in: '10', cm: '25.4' },
      },
      {
        Size: "US Men's 8",
        'EU 41-42': { in: '10 1/4', cm: '26' },
      },
      {
        Size: "US Men's 9",
        'EU 43': { in: '10 3/4', cm: '27.3' },
      },
      {
        Size: "US Men's 10",
        'EU 44': { in: '11', cm: '27.9' },
      },
      {
        Size: "US Men's 11",
        'EU 45': { in: '11 1/2', cm: '29.2' },
      },
      {
        Size: "US Men's 12",
        'EU 46': { in: '11 3/4', cm: '29.8' },
      },
    ],
  },
};
